import { loadAndFormatApiBreweriesList } from '../breweryDataConsts';
import { stringArrayToSelectOptions } from '@ab-inbev/sam-utils';
import { useQuery } from '@tanstack/react-query';
import { useQueryFallBack } from '../../useQueryFallback';
import { useUserProfileClient } from '../userProfileApiClient';
import { Brewery } from '../../../user-profile/codegen';

// Transform data for use in search bar
export const selectBreweryListAsSearchBar = (data: Brewery[]) => loadAndFormatApiBreweriesList(data);

// Transform data for use in select dropdown
export const selectBreweryListAsSelectOptions = (data: Brewery[]) =>
  stringArrayToSelectOptions(loadAndFormatApiBreweriesList(data));

export const useBreweryListQuery = <TData>(select?: (data: Brewery[]) => TData, throwOnError = true) => {
  const { createClient } = useUserProfileClient();
  return useQuery({
    queryKey: ['useBreweryListQuery'],
    queryFn: async () => (await createClient()).brewDat.brewDatGetBrewery(),
    select,
    throwOnError
  });
};

export const useBreweryListQueryWithFallback = <TData>(fallbackData: TData, select?: (data: Brewery[]) => TData) => {
  const result = useBreweryListQuery(select, false);
  return useQueryFallBack(result, fallbackData, 'Brewdat GET breweries (useBreweryListQueryWithFallback)');
};
